import { useEffect } from 'react';
import { ThemeModeProvider } from './context/ThemeContext';
import Router from './presentation/routes/Router';
import { LanguageProvider } from './context/LanguageContext';
import { initRecaptchaConsentGate } from './utils/CookieConsent';

export default function App() {
    // Firebase is initialized in index.tsx before React renders
    // This ensures all components have access to Firebase immediately

    // reCAPTCHA api.js is consent-gated (no longer a static index.html script)
    useEffect(() => {
        initRecaptchaConsentGate();
    }, []);

    // Global resize handler to fix responsive layout issues
    useEffect(() => {
        let resizeTimeout: NodeJS.Timeout | null = null;

        const handleResize = () => {
            // Debounce resize events
            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }

            resizeTimeout = setTimeout(() => {
                // Refresh ScrollTrigger to recalculate all scroll-based animations
                if (typeof window !== 'undefined' && (window as any).ScrollTrigger) {
                    (window as any).ScrollTrigger.refresh();
                }

                // Update all Swiper instances
                if (typeof window !== 'undefined' && (window as any).Swiper) {
                    // Find all Swiper instances and update them
                    const swiperElements = document.querySelectorAll('.swiper');
                    swiperElements.forEach((el: Element) => {
                        const swiperInstance = (el as any).swiper;
                        if (swiperInstance && typeof swiperInstance.update === 'function') {
                            swiperInstance.update();
                            if (typeof swiperInstance.updateSize === 'function') {
                                swiperInstance.updateSize();
                            }
                            if (typeof swiperInstance.updateSlides === 'function') {
                                swiperInstance.updateSlides();
                            }
                        }
                    });
                }

                // Use requestAnimationFrame to ensure DOM is ready before final refresh
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        // Final refresh after all layout calculations are complete
                        if (typeof window !== 'undefined' && (window as any).ScrollTrigger) {
                            (window as any).ScrollTrigger.refresh();
                        }
                    });
                });

            }, 250);
        };

        // Add resize listener
        window.addEventListener('resize', handleResize);
        
        // Also handle orientation change (mobile devices)
        window.addEventListener('orientationchange', () => {
            setTimeout(handleResize, 500);
        });

        return () => {
            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <ThemeModeProvider>
                <LanguageProvider>
                            <Router />
                </LanguageProvider>
            </ThemeModeProvider>
        </>
    );
}

